import React, { useEffect, useState } from 'react';
import webPortalServices from '../../services/webPortal.services';
import { Link, NavLink } from 'react-router-dom';
import Logo from '../assets/img/logo.png';


const Header = () => {
    const [menuList, setMenuList] = useState([]);
    const [dynamicMenuList, setDynamicMenuList] =useState([])
    const [isToggole, setIsToggle] = useState(false);
    useEffect(()=>{
     webPortalServices.customizedData().then((res)=>{
      const data = res.data.webNavMenuList.filter(item => item.status === 1 && item.pageType===0);
      setMenuList(data)
      const dynPage = res.data.webNavMenuList.filter(item=>item.status ===1 && item.pageType===1)
      setDynamicMenuList(dynPage)
    });
  },[])


  const mobileToggle = () => {
    setIsToggle((prevState) => prevState ? false : true)
  }

  const onClickMenu = () => {
    setIsToggle(false)
  }
    return (
        <header className="main-header">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-6 col-sm-4">
                        <Link to="/testigo/home">
                            <div className="logo">
                                <img src={Logo} alt="Logo" />
                            </div>
                        </Link>
                    </div>
                    <div className="col-6 col-sm-8">
                        <ul className={`nav-links ${isToggole && "nav-active"}`}>
                            {menuList?.map((item,index)=>{
                                return(
                                    // <a href={item.pageUrl}>{item.pageTitle}</a>
                                    <NavLink to={`${item.pageUrl}`} key={item._id} onClick={onClickMenu}>
                                        {item.pageTitle}
                                    </NavLink>
                                )
                            })}
                             {dynamicMenuList?.map((item,index)=>{
                                return(
                                    <NavLink to={`page/${item.pageUrl}`} key={item._id}  onClick={onClickMenu}>
                                        {item.pageTitle}
                                    </NavLink>
                                )
                            })}
                            {/* <a href="http://103.15.67.180:3000/" className="btn custom-btn">Book Now</a> */}
                            {/* <a href>Home</a>
                            <a href="#">Services</a>
                            <a href="about.html">About</a>
                            <a href="#">Contact Us</a>
                            <a href="#">Register</a>
                            <a href="http://103.15.67.180:3000/" className="btn custom-btn">Book Now</a> */}
                            {/* <NavLink to="/">Home</NavLink>
                            <NavLink to="#">Services</NavLink>
                            <NavLink to="#">About</NavLink>
                            <NavLink to="#">Contact Us</NavLink>
                            <NavLink to="#">Register</NavLink> */}
                            {/* <Link to="http://103.15.67.180:3000/" className="btn custom-btn">Book Now</Link> */}
                            <NavLink to="/login" className="btn custom-btn mt-2 mt-lg-0">Admin</NavLink>
                        </ul>
                        <div className={`burger ${isToggole && "toggle"}`} onClick={mobileToggle}>
                            <div className="line1" />
                            <div className="line2" />
                            <div className="line3" />
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;